import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 mb-4" }
const _hoisted_6 = { class: "row g-3 pt-4" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "fw-semibold mb-0" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "fw-semibold mb-0" }
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = { class: "fw-semibold mb-0" }
const _hoisted_13 = { class: "col-md-2" }
const _hoisted_14 = { class: "fw-semibold mb-0" }
const _hoisted_15 = { class: "col-md-2" }
const _hoisted_16 = { class: "fw-semibold mb-0" }
const _hoisted_17 = { class: "row g-3 pt-4" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "fw-semibold mb-0" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "fw-semibold mb-0" }
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "fw-semibold mb-0" }
const _hoisted_24 = { class: "col-md-2" }
const _hoisted_25 = { class: "fw-semibold mb-0" }
const _hoisted_26 = { class: "col-md-2" }
const _hoisted_27 = { class: "fw-semibold mb-0" }
const _hoisted_28 = { class: "row g-3 pt-4" }
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = { class: "fw-semibold mb-0" }
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = { class: "fw-semibold mb-0" }
const _hoisted_33 = { class: "col-md-2" }
const _hoisted_34 = { class: "fw-semibold mb-0" }
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = { class: "fw-semibold mb-0" }
const _hoisted_37 = { class: "col-md-2" }
const _hoisted_38 = { class: "fw-semibold mb-0" }
const _hoisted_39 = { class: "row g-3 pt-4" }
const _hoisted_40 = { class: "col-md-3" }
const _hoisted_41 = { class: "fw-semibold mb-0" }
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = { class: "fw-semibold mb-0" }
const _hoisted_44 = { class: "col-md-2" }
const _hoisted_45 = { class: "fw-semibold mb-0" }
const _hoisted_46 = { class: "col-md-2" }
const _hoisted_47 = { class: "fw-semibold mb-0" }
const _hoisted_48 = { class: "col-md-2" }
const _hoisted_49 = { class: "fw-semibold mb-0" }
const _hoisted_50 = { class: "row g-3 pt-4" }
const _hoisted_51 = { class: "col-md-3" }
const _hoisted_52 = { class: "fw-semibold mb-0" }
const _hoisted_53 = { class: "col-md-3" }
const _hoisted_54 = { class: "fw-semibold mb-0" }
const _hoisted_55 = { class: "col-md-2" }
const _hoisted_56 = { class: "fw-semibold mb-0" }
const _hoisted_57 = { class: "col-md-2" }
const _hoisted_58 = { class: "fw-semibold mb-0" }
const _hoisted_59 = { class: "col-md-2" }
const _hoisted_60 = { class: "fw-semibold mb-0" }
const _hoisted_61 = { class: "row g-3 pt-4" }
const _hoisted_62 = { class: "col-md-3" }
const _hoisted_63 = { class: "fw-semibold mb-0" }
const _hoisted_64 = { class: "col-md-3" }
const _hoisted_65 = { class: "fw-semibold mb-0" }
const _hoisted_66 = { class: "col-md-2" }
const _hoisted_67 = { class: "fw-semibold mb-0" }
const _hoisted_68 = { class: "col-md-2" }
const _hoisted_69 = { class: "fw-semibold mb-0" }
const _hoisted_70 = {
  key: 0,
  class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 mb-4"
}
const _hoisted_71 = { class: "table table-hover" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  key: 1,
  class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25"
}
const _hoisted_74 = { class: "table table-hover" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = {
  class: "modal fade",
  id: "equipementModal",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "equipementModal"
}
const _hoisted_77 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_78 = { class: "modal-content shadow-lg border-0" }
const _hoisted_79 = { class: "modal-body p-4" }
const _hoisted_80 = { class: "card border-0 bg-light mb-4" }
const _hoisted_81 = { class: "card-body" }
const _hoisted_82 = { class: "row g-3" }
const _hoisted_83 = { class: "col-md-1" }
const _hoisted_84 = { class: "fw-semibold mb-0" }
const _hoisted_85 = { class: "col-md-2" }
const _hoisted_86 = { class: "fw-semibold mb-0" }
const _hoisted_87 = { class: "col-md-2" }
const _hoisted_88 = { class: "fw-semibold mb-0" }
const _hoisted_89 = { class: "col-md-2" }
const _hoisted_90 = { class: "fw-semibold mb-0" }
const _hoisted_91 = { class: "col-md-1" }
const _hoisted_92 = { class: "fw-semibold mb-0" }
const _hoisted_93 = { class: "col-md-2" }
const _hoisted_94 = { class: "fw-semibold mb-0" }
const _hoisted_95 = { class: "badge bg-primary-subtle text-primary" }
const _hoisted_96 = { class: "col-md-2" }
const _hoisted_97 = { class: "fw-semibold mb-0" }
const _hoisted_98 = { class: "row g-3" }
const _hoisted_99 = { class: "col-md-1" }
const _hoisted_100 = { class: "fw-semibold mb-0" }
const _hoisted_101 = { class: "col-md-2" }
const _hoisted_102 = { class: "fw-semibold mb-0" }
const _hoisted_103 = { class: "col-md-2" }
const _hoisted_104 = { class: "fw-semibold mb-0" }
const _hoisted_105 = { class: "col-md-2" }
const _hoisted_106 = { class: "fw-semibold mb-0" }
const _hoisted_107 = { class: "col-md-1" }
const _hoisted_108 = { class: "fw-semibold mb-0" }
const _hoisted_109 = { class: "col-md-2" }
const _hoisted_110 = { class: "fw-semibold mb-0" }
const _hoisted_111 = { class: "col-md-2" }
const _hoisted_112 = { class: "fw-semibold mb-0" }
const _hoisted_113 = {
  key: 0,
  class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 mb-4"
}
const _hoisted_114 = { class: "row g-1 mb-2" }
const _hoisted_115 = { class: "col-md-2" }
const _hoisted_116 = { class: "col-md-1" }
const _hoisted_117 = { class: "col-md-2" }
const _hoisted_118 = { class: "col-md-1" }
const _hoisted_119 = { class: "col-md-1" }
const _hoisted_120 = { class: "col-md-1" }
const _hoisted_121 = { class: "col-md-1" }
const _hoisted_122 = { class: "col-md-2" }
const _hoisted_123 = { class: "row g-2" }
const _hoisted_124 = { class: "col-md-2" }
const _hoisted_125 = { class: "col-md-1" }
const _hoisted_126 = { class: "col-md-2" }
const _hoisted_127 = { class: "col-md-1" }
const _hoisted_128 = { class: "col-md-1" }
const _hoisted_129 = { class: "col-md-1" }
const _hoisted_130 = { class: "col-md-1" }
const _hoisted_131 = { class: "col-md-1" }
const _hoisted_132 = {
  key: 1,
  class: "text-center py-3 text-muted"
}
const _hoisted_133 = { class: "modal-footer bg-light border-0" }
const _hoisted_134 = {
  class: "modal fade",
  id: "marchandiseModal",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "marchandiseModal"
}
const _hoisted_135 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_136 = { class: "modal-content shadow-lg border-0" }
const _hoisted_137 = { class: "modal-body p-4" }
const _hoisted_138 = { class: "card border-0 bg-light mb-4" }
const _hoisted_139 = { class: "card-body" }
const _hoisted_140 = { class: "row g-3" }
const _hoisted_141 = { class: "col-md-2" }
const _hoisted_142 = { class: "fw-semibold mb-0" }
const _hoisted_143 = { class: "col-md-2" }
const _hoisted_144 = { class: "fw-semibold mb-0" }
const _hoisted_145 = { class: "col-md-2" }
const _hoisted_146 = { class: "fw-semibold mb-0" }
const _hoisted_147 = { class: "col-md-2" }
const _hoisted_148 = { class: "fw-semibold mb-0" }
const _hoisted_149 = { class: "col-md-2" }
const _hoisted_150 = { class: "fw-semibold mb-0" }
const _hoisted_151 = { class: "col-md-2" }
const _hoisted_152 = { class: "fw-semibold mb-0" }
const _hoisted_153 = { class: "row g-3 mt-3" }
const _hoisted_154 = { class: "col-md-2" }
const _hoisted_155 = { class: "fw-semibold mb-0" }
const _hoisted_156 = { class: "col-md-2" }
const _hoisted_157 = { class: "fw-semibold mb-0" }
const _hoisted_158 = { class: "col-md-2" }
const _hoisted_159 = { class: "fw-semibold mb-0" }
const _hoisted_160 = { class: "col-md-2" }
const _hoisted_161 = { class: "fw-semibold mb-0" }
const _hoisted_162 = { class: "col-md-2" }
const _hoisted_163 = { class: "fw-semibold mb-0" }
const _hoisted_164 = { class: "col-md-2" }
const _hoisted_165 = { class: "fw-semibold mb-0" }
const _hoisted_166 = { class: "row g-3 mt-3" }
const _hoisted_167 = { class: "col-md-2" }
const _hoisted_168 = { class: "fw-semibold mb-0" }
const _hoisted_169 = { class: "col-md-2" }
const _hoisted_170 = { class: "fw-semibold mb-0" }
const _hoisted_171 = { class: "col-md-2" }
const _hoisted_172 = { class: "fw-semibold mb-0" }
const _hoisted_173 = { class: "col-md-2" }
const _hoisted_174 = { class: "fw-semibold mb-0" }
const _hoisted_175 = { class: "col-md-2" }
const _hoisted_176 = { class: "fw-semibold mb-0" }
const _hoisted_177 = { class: "modal-footer bg-light border-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "d-lg-flex align-items-center justify-content-between mb-3" }, [
                _createElementVNode("h4", { class: "position-relative text-primary fw-bold mb-0" }, "Détail du document")
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[2] || (_cache[2] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Type", -1)),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.document?.type), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[3] || (_cache[3] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Arm", -1)),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.document?.arm), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Num", -1)),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.document?.num), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Sic", -1)),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.document?.sic), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Otc", -1)),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.document?.etd || 'N/A'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Refotc", -1)),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.document?.refotc || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Transit", -1)),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.document?.transit), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-muted small mb-1" }, "IdAtpTbt", -1)),
                  _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.document?.idAtpTbt || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-muted small mb-1" }, "RefArmTbt", -1)),
                  _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.document?.refArmTbt || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Pec", -1)),
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.document?.pec || 'N/A'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-muted small mb-1" }, "PecLib", -1)),
                  _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.document?.pecLib || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-muted small mb-1" }, "First", -1)),
                  _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.document?.first), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-muted small mb-1" }, "FirstLib", -1)),
                  _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.document?.firstLib), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Last", -1)),
                  _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.document?.last), 1)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Last Lib", -1)),
                  _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.document?.lastLib), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Pod", -1)),
                  _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.document?.pod), 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Pod Lib", -1)),
                  _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.document?.podLib), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Last pod", -1)),
                  _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.document?.lastpod), 1)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Fin", -1)),
                  _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.document?.fin), 1)
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Fin Lib", -1)),
                  _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.document?.finLib), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "text-muted small mb-1" }, "PaysDest", -1)),
                  _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.document?.paysDest || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Pays DestLib", -1)),
                  _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.document?.paysDestLib || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Shipper Code", -1)),
                  _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.document?.shipperCode || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _cache[25] || (_cache[25] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Shipper Type", -1)),
                  _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.document?.shipperType || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Shipper Name", -1)),
                  _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.document?.shipperName || 'N/A'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Type Destinataire", -1)),
                  _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.document?.consigneeType || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _cache[28] || (_cache[28] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Destinataire", -1)),
                  _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.document?.consigneeName || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Code Notification", -1)),
                  _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.document?.notifyCode || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Notify Type", -1)),
                  _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.document?.notifyType || 'N/A'), 1)
                ])
              ])
            ]),
            (_ctx.equipements.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _cache[33] || (_cache[33] = _createElementVNode("h5", { class: "fw-bold mb-3 text-primary" }, "Équipements", -1)),
                  _createElementVNode("table", _hoisted_71, [
                    _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Lieu"),
                        _createElementVNode("th", null, "Lieu Lib"),
                        _createElementVNode("th", null, "Manut"),
                        _createElementVNode("th", null, "Manut Lib"),
                        _createElementVNode("th", null, "Nb"),
                        _createElementVNode("th", null, "Poids"),
                        _createElementVNode("th", null, "Sic"),
                        _createElementVNode("th", null, "Actions")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipements, (equip, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(equip.lieu), 1),
                          _createElementVNode("td", null, _toDisplayString(equip.lieuLib), 1),
                          _createElementVNode("td", null, _toDisplayString(equip.manut), 1),
                          _createElementVNode("td", null, _toDisplayString(equip.manutLib), 1),
                          _createElementVNode("td", null, _toDisplayString(equip.nb), 1),
                          _createElementVNode("td", null, _toDisplayString(equip.poids), 1),
                          _createElementVNode("td", null, _toDisplayString(equip.sic), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-primary",
                              onClick: ($event: any) => (_ctx.goToEquipDetail(equip))
                            }, " Voir les détails ", 8, _hoisted_72)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.marchandises.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                  _cache[35] || (_cache[35] = _createElementVNode("h5", { class: "fw-bold mb-3 text-primary" }, "Marchandises", -1)),
                  _createElementVNode("table", _hoisted_74, [
                    _cache[34] || (_cache[34] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Code Lib"),
                        _createElementVNode("th", null, "Code SH"),
                        _createElementVNode("th", null, "ItemNumber"),
                        _createElementVNode("th", null, "Mrn"),
                        _createElementVNode("th", null, "Nb"),
                        _createElementVNode("th", null, "Poids"),
                        _createElementVNode("th", null, "Ref"),
                        _createElementVNode("th", null, "Actions")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marchandises, (march, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(march.codeLib), 1),
                          _createElementVNode("td", null, _toDisplayString(march.codeSH), 1),
                          _createElementVNode("td", null, _toDisplayString(march.itemNumber), 1),
                          _createElementVNode("td", null, _toDisplayString(march.mrn), 1),
                          _createElementVNode("td", null, _toDisplayString(march.nb), 1),
                          _createElementVNode("td", null, _toDisplayString(march.poids), 1),
                          _createElementVNode("td", null, _toDisplayString(march.ref), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-primary",
                              onClick: ($event: any) => (_ctx.goToMarchDetail(march))
                            }, " Voir les détails ", 8, _hoisted_75)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _cache[50] || (_cache[50] = _createElementVNode("h6", { class: "text-primary fw-bold mb-3" }, [
                  _createElementVNode("i", { class: "bi bi-info-circle me-2" }),
                  _createTextVNode("Informations Equipement ")
                ], -1)),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _cache[36] || (_cache[36] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Tare", -1)),
                    _createElementVNode("p", _hoisted_84, _toDisplayString(_ctx.selectedEquipement?.tare), 1)
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _cache[37] || (_cache[37] = _createElementVNode("label", { class: "text-muted small mb-1" }, "NB", -1)),
                    _createElementVNode("p", _hoisted_86, _toDisplayString(_ctx.selectedEquipement?.nb), 1)
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Code", -1)),
                    _createElementVNode("p", _hoisted_88, _toDisplayString(_ctx.selectedEquipement?.code), 1)
                  ]),
                  _createElementVNode("div", _hoisted_89, [
                    _cache[39] || (_cache[39] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Code Lib", -1)),
                    _createElementVNode("p", _hoisted_90, _toDisplayString(_ctx.selectedEquipement?.codeLib), 1)
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _cache[40] || (_cache[40] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Poids", -1)),
                    _createElementVNode("p", _hoisted_92, _toDisplayString(_ctx.selectedEquipement?.poids), 1)
                  ]),
                  _createElementVNode("div", _hoisted_93, [
                    _cache[41] || (_cache[41] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Sic", -1)),
                    _createElementVNode("p", _hoisted_94, [
                      _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.selectedEquipement?.sic || 'N/A'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Long", -1)),
                    _createElementVNode("p", _hoisted_97, _toDisplayString(_ctx.selectedEquipement?.long || 'N/A'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _cache[43] || (_cache[43] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Vol", -1)),
                    _createElementVNode("p", _hoisted_100, _toDisplayString(_ctx.selectedEquipement?.vol || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    _cache[44] || (_cache[44] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Manut", -1)),
                    _createElementVNode("p", _hoisted_102, _toDisplayString(_ctx.selectedEquipement?.manut), 1)
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _cache[45] || (_cache[45] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Manut Lib", -1)),
                    _createElementVNode("p", _hoisted_104, _toDisplayString(_ctx.selectedEquipement?.manutLib || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _cache[46] || (_cache[46] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Zone", -1)),
                    _createElementVNode("p", _hoisted_106, _toDisplayString(_ctx.selectedEquipement?.zone || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_107, [
                    _cache[47] || (_cache[47] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Zone Lib", -1)),
                    _createElementVNode("p", _hoisted_108, _toDisplayString(_ctx.selectedEquipement?.zoneLib || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _cache[48] || (_cache[48] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Lieu", -1)),
                    _createElementVNode("p", _hoisted_110, _toDisplayString(_ctx.selectedEquipement?.lieu || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _cache[49] || (_cache[49] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Lieu Lib", -1)),
                    _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.selectedEquipement?.lieuLib || 'N/A'), 1)
                  ])
                ])
              ])
            ]),
            (_ctx.selectedEquipement?.marchandises?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                  _cache[68] || (_cache[68] = _createElementVNode("h6", { class: "text-primary fw-bold mb-3" }, "Marchandises", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedEquipement.marchandises, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "mb-3 pb-2 border-bottom"
                    }, [
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("div", _hoisted_115, [
                          _cache[51] || (_cache[51] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Sic", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.sic || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_116, [
                          _cache[52] || (_cache[52] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Ref", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.ref || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_117, [
                          _cache[53] || (_cache[53] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Eqd", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.eqd || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_118, [
                          _cache[54] || (_cache[54] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Nb", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.nb || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_119, [
                          _cache[55] || (_cache[55] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Code", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.code || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_120, [
                          _cache[56] || (_cache[56] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Code Lib", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.codeLib || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_121, [
                          _cache[57] || (_cache[57] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Poids", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.poids || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_122, [
                          _cache[58] || (_cache[58] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Poids net", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.poidsnet || 'N/A'), 1)
                        ])
                      ]),
                      _cache[67] || (_cache[67] = _createElementVNode("hr", null, null, -1)),
                      _createElementVNode("div", _hoisted_123, [
                        _createElementVNode("div", _hoisted_124, [
                          _cache[59] || (_cache[59] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Marques", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.marques || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_125, [
                          _cache[60] || (_cache[60] = _createElementVNode("p", { class: "fw-bold mb-1" }, "ItemNumber", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.itemNumber || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_126, [
                          _cache[61] || (_cache[61] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Mrn", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.mrn || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_127, [
                          _cache[62] || (_cache[62] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Code SH", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.codeSH || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_128, [
                          _cache[63] || (_cache[63] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Zone", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.zone || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_129, [
                          _cache[64] || (_cache[64] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Zone Lib", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.zoneLib || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_130, [
                          _cache[65] || (_cache[65] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Lieu", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.lieu || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_131, [
                          _cache[66] || (_cache[66] = _createElementVNode("p", { class: "fw-bold mb-1" }, "Lieu Lib", -1)),
                          _createElementVNode("p", null, _toDisplayString(item.lieuLib || 'N/A'), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_132, [...(_cache[69] || (_cache[69] = [
                  _createElementVNode("p", { class: "mb-0" }, "Aucune marchandise associée à cet équipement", -1)
                ]))]))
          ]),
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, [...(_cache[70] || (_cache[70] = [
              _createElementVNode("i", { class: "bi bi-x-circle me-2" }, null, -1),
              _createTextVNode("Fermer ", -1)
            ]))])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_134, [
      _createElementVNode("div", _hoisted_135, [
        _createElementVNode("div", _hoisted_136, [
          _createElementVNode("div", _hoisted_137, [
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("div", _hoisted_139, [
                _cache[88] || (_cache[88] = _createElementVNode("h6", { class: "text-primary fw-bold mb-3" }, [
                  _createElementVNode("i", { class: "bi bi-info-circle me-2" }),
                  _createTextVNode("Informations Marchandise ")
                ], -1)),
                _createElementVNode("div", _hoisted_140, [
                  _createElementVNode("div", _hoisted_141, [
                    _cache[71] || (_cache[71] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Sic", -1)),
                    _createElementVNode("p", _hoisted_142, _toDisplayString(_ctx.selectedMarchandise?.sic), 1)
                  ]),
                  _createElementVNode("div", _hoisted_143, [
                    _cache[72] || (_cache[72] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Ref", -1)),
                    _createElementVNode("p", _hoisted_144, _toDisplayString(_ctx.selectedMarchandise?.ref), 1)
                  ]),
                  _createElementVNode("div", _hoisted_145, [
                    _cache[73] || (_cache[73] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Eqd", -1)),
                    _createElementVNode("p", _hoisted_146, _toDisplayString(_ctx.selectedMarchandise?.eqd || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_147, [
                    _cache[74] || (_cache[74] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Nb", -1)),
                    _createElementVNode("p", _hoisted_148, _toDisplayString(_ctx.selectedMarchandise?.nb || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_149, [
                    _cache[75] || (_cache[75] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Code", -1)),
                    _createElementVNode("p", _hoisted_150, _toDisplayString(_ctx.selectedMarchandise?.code), 1)
                  ]),
                  _createElementVNode("div", _hoisted_151, [
                    _cache[76] || (_cache[76] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Code Lib", -1)),
                    _createElementVNode("p", _hoisted_152, _toDisplayString(_ctx.selectedMarchandise?.codeLib || 'N/A'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_153, [
                  _createElementVNode("div", _hoisted_154, [
                    _cache[77] || (_cache[77] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Poids", -1)),
                    _createElementVNode("p", _hoisted_155, _toDisplayString(_ctx.selectedMarchandise?.poids || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_156, [
                    _cache[78] || (_cache[78] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Poids Net", -1)),
                    _createElementVNode("p", _hoisted_157, _toDisplayString(_ctx.selectedMarchandise?.poidsnet || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_158, [
                    _cache[79] || (_cache[79] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Marques", -1)),
                    _createElementVNode("p", _hoisted_159, _toDisplayString(_ctx.selectedMarchandise?.marques || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_160, [
                    _cache[80] || (_cache[80] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Mrn", -1)),
                    _createElementVNode("p", _hoisted_161, _toDisplayString(_ctx.selectedMarchandise?.mrn), 1)
                  ]),
                  _createElementVNode("div", _hoisted_162, [
                    _cache[81] || (_cache[81] = _createElementVNode("label", { class: "text-muted small mb-1" }, "StatComm", -1)),
                    _createElementVNode("p", _hoisted_163, _toDisplayString(_ctx.selectedMarchandise?.statComm), 1)
                  ]),
                  _createElementVNode("div", _hoisted_164, [
                    _cache[82] || (_cache[82] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Item Number", -1)),
                    _createElementVNode("p", _hoisted_165, _toDisplayString(_ctx.selectedMarchandise?.itemNumber || 'N/A'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_166, [
                  _createElementVNode("div", _hoisted_167, [
                    _cache[83] || (_cache[83] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Code SH", -1)),
                    _createElementVNode("p", _hoisted_168, _toDisplayString(_ctx.selectedMarchandise?.codeSH || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_169, [
                    _cache[84] || (_cache[84] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Zone", -1)),
                    _createElementVNode("p", _hoisted_170, _toDisplayString(_ctx.selectedMarchandise?.zone || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_171, [
                    _cache[85] || (_cache[85] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Zone Lib", -1)),
                    _createElementVNode("p", _hoisted_172, _toDisplayString(_ctx.selectedMarchandise?.zoneLib || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_173, [
                    _cache[86] || (_cache[86] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Lieu", -1)),
                    _createElementVNode("p", _hoisted_174, _toDisplayString(_ctx.selectedMarchandise?.lieu || 'N/A'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_175, [
                    _cache[87] || (_cache[87] = _createElementVNode("label", { class: "text-muted small mb-1" }, "Lieu Lib", -1)),
                    _createElementVNode("p", _hoisted_176, _toDisplayString(_ctx.selectedMarchandise?.lieuLib || 'N/A'), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_177, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal2 && _ctx.closeModal2(...args)))
            }, [...(_cache[89] || (_cache[89] = [
              _createElementVNode("i", { class: "bi bi-x-circle me-2" }, null, -1),
              _createTextVNode("Fermer ", -1)
            ]))])
          ])
        ])
      ])
    ], 512)
  ], 64))
}